import React, { useState, useEffect, useRef, useCallback } from "react";
import RechercheDataService from "../services/recherche.service";
import { useRouter } from './withRouter';
import { useToast } from './common/Toast';
import useApi from '../hooks/useApi';
import logger from '../utils/logger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const GlobalSearch = () => {
  const router = useRouter();
  const { showError, showWarning } = useToast();
  const { } = useApi();
  const formRef = useRef();

  const heroUrl = `${process.env.PUBLIC_URL}/hero.jpg`;

  // États du composant
  const [state, setState] = useState({
    alldata: [],
    alldatalieu: [],
    type_data: "",
    doctors: [],
    structures: [],
    specialites: [],
    specialites_str: [],
    currentIndex: -1,
    searchName: "",
    searchSpec: "",
    searchLieu: "",
    focusedLieu: false,
    id_structure: "",
    id_specialite: "",
    id_lieu: "",
    show: false,
    show2: false,
    spec_option: []
  });

  // Refs pour les timeouts de debounce
  const searchNameTimeoutRef = useRef(null);
  const searchLieuTimeoutRef = useRef(null);

  const onChangeSearchName = useCallback((text) => {
    setState(prev => ({ ...prev, searchName: text }));
    
    // Nettoyer le timeout précédent
    if (searchNameTimeoutRef.current) {
      clearTimeout(searchNameTimeoutRef.current);
    }
    
    // Créer un nouveau timeout
    searchNameTimeoutRef.current = setTimeout(async () => {
      if (text.length > 2) {
        try {
          const response = await RechercheDataService.searchAllByName(text);
          setState(prev => ({ ...prev, alldata: response.data }));
          logger.log('Recherche par nom réussie:', response.data);
        } catch (err) {
          logger.error('Erreur recherche par nom:', err);
          showError('Erreur lors de la recherche');
        }
      } else {
        setState(prev => ({
          ...prev,
          alldata: [],
          id_structure: "",
          id_specialite: ""
        }));
      }
    }, 300);
  }, [showError]);

  const onChangeLieu = useCallback((text) => {
    setState(prev => ({ ...prev, searchLieu: text }));
    
    // Nettoyer le timeout précédent
    if (searchLieuTimeoutRef.current) {
      clearTimeout(searchLieuTimeoutRef.current);
    }
    
    // Créer un nouveau timeout
    searchLieuTimeoutRef.current = setTimeout(async () => {
      if (text.length > 2) {
        try {
          const response = await RechercheDataService.searchLieu(text);
          setState(prev => ({ ...prev, alldatalieu: response.data }));
          logger.log('Recherche lieu réussie:', response.data);
        } catch (err) {
          logger.error('Erreur recherche lieu:', err);
          showError('Erreur lors de la recherche de lieu');
        }
      } else {
        setState(prev => ({
          ...prev,
          alldatalieu: [],
          id_lieu: ""
        }));
      }
    }, 300);
  }, [showError]);

  const onFocusLieu = useCallback(() => {
    setState(prev => ({ ...prev, focusedLieu: true }));
  }, []);

  const onFocusOutLieu = useCallback(() => {
    setState(prev => ({ ...prev, focusedLieu: false }));
  }, []);

  const onClickSelectDoctor = useCallback((id, nom) => {
    router.push(`/resultDoctor/${id}`);
  }, [router]);

  const onClickDisplayLieuSpec = useCallback((lieu, spec) => {
    if (lieu !== '' && spec !== '') {
      router.push(`/resultSpecialiteLieu/${lieu}&${spec}`);
    } else {
      setState(prev => ({ ...prev, show2: true }));
    }
  }, [router]);

  const onClickSelectStructure = useCallback(async (id, nom) => {
    setState(prev => ({
      ...prev,
      alldata: [],
      searchName: nom,
      id_structure: id,
      show: true
    }));

    try {
      const response = await RechercheDataService.searchSpecialitesFromStructure2(id);
      setState(prev => ({ ...prev, spec_option: response.data }));
      logger.log('Spécialités de structure récupérées:', response.data);
      // Debug: afficher la structure des données
      console.log('Structure des spécialités:', response.data);
      if (response.data && response.data.length > 0) {
        console.log('Premier élément:', response.data[0]);
        console.log('Clés disponibles:', Object.keys(response.data[0]));
      }
    } catch (err) {
      logger.error('Erreur récupération spécialités:', err);
      showError('Erreur lors de la récupération des spécialités');
    }
  }, [showError]);

  const onClickSelectSpecialite = useCallback((id, nom) => {
    setState(prev => ({
      ...prev,
      alldata: [],
      searchName: nom,
      id_specialite: id
    }));
  }, []);

  const onClickSelectLieu = useCallback((id, nom) => {
    setState(prev => ({
      ...prev,
      alldatalieu: [],
      focusedLieu: false,
      searchLieu: nom,
      id_lieu: id
    }));
  }, []);

  const onChangeSpecialite = useCallback((id) => {
    setState(prev => ({ ...prev, id_specialite: id }));
  }, []);

  const openStructure = useCallback((str, spec) => {
    if (spec === '') {
      showWarning('Veuillez sélectionner une spécialité');
    } else {
      router.push(`/resultStructure/${str}&${spec}`);
    }
  }, [router, showWarning]);

  const handleClose = useCallback(() => {
    setState(prev => ({ ...prev, show: false }));
  }, []);

  const handleClose2 = useCallback(() => {
    setState(prev => ({ ...prev, show2: false }));
  }, []);

  // Nettoyage des timeouts au démontage
  useEffect(() => {
    return () => {
      if (searchNameTimeoutRef.current) {
        clearTimeout(searchNameTimeoutRef.current);
      }
      if (searchLieuTimeoutRef.current) {
        clearTimeout(searchLieuTimeoutRef.current);
      }
    };
  }, []);

  // Préchargement programmatique de l'image de fond pour accélérer l'affichage
  useEffect(() => {
    const img = new Image();
    img.src = heroUrl;
  }, []);

  return (
    <div className="col-md-12 p-lg-5 mx-auto" style={{
      backgroundImage: `linear-gradient(rgba(110, 66, 193, 0.46), rgba(111,66,193,0.46)), url('${heroUrl}')`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }}>
              
              <Modal show={state.show} onHide={handleClose} style={{overflow:"auto"}}>
                <Modal.Header closeButton>
                  <Modal.Title>Spécialités disponibles</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <form className="needs-validation" novalidate ref={formRef} onSubmit={(e) => {
                    e.preventDefault();
                    openStructure(state.id_structure, state.id_specialite);
                  }}>
                    {state.searchName}
                    <div className="mb-3">
                      <Select 
                        required 
                        options={state.spec_option}
                        placeholder="Sélectionner la Spécialité" 
                        onChange={e => onChangeSpecialite(e.value)}
                        noOptionsMessage={() => "Aucune spécialité disponible"}
                      />
                    </div>
                    <Button variant="primary" type="submit">
                      Valider
                    </Button>
                  </form>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
              </Modal>

              <Modal show={state.show2} style={{overflow:"auto"}}>
                <Modal.Header>
                  <Modal.Title>Attention!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Veuillez sélectionner la spécialité et le lieu souhaités.
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose2}>
                    Fermer
                  </Button>
                </Modal.Footer>
              </Modal>

                <h3 className="display-6 text-center" style={{color:"white"}}>Besoin d'une consultation?</h3>
                <h3 className="display-6 text-center" style={{marginBottom:"50px",color:"white"}}>Trouvez l'offre de service qui vous convient!</h3>
                
                <div className="input-group input-group-lg" style={{marginBottom:"0px"}}>
                  <span style={{color:"gray"}} className="input-group-text"><FontAwesomeIcon icon={solid('search')}/></span>
                  <input
                    type="search" 
                    className="form-control" 
                    placeholder="Médecin, structure de santé ou spécialité"
                    value={state.searchName}
                    onChange={e => onChangeSearchName(e.target.value)}
                  />
                  <span style={{color:"gray"}} className="input-group-text"><FontAwesomeIcon icon={solid('location-dot')}/></span>
                  <input
                    type="search" 
                    className="form-control" 
                    placeholder="Lieu"
                    value={state.searchLieu}
                    onChange={e => onChangeLieu(e.target.value)}
                    onFocus={onFocusLieu}
                    onBlur={onFocusOutLieu}
                  />
                  <button 
                    className="btn btn-dark" 
                    type="button" 
                    onClick={() => onClickDisplayLieuSpec(state.id_lieu, state.id_specialite)}
                  >
                      Rechercher
                  </button>
                </div>

                <table style={{width:"100%"}}>
                  <tbody>
                  <tr>
                    <td style={{width:"50%"}}>
                  {(state.alldata.length > 0 &&
                    <div className="list-group" style={{width:"45%",position:"absolute",zIndex:"auto",height:"300px",overflow:"auto"}}>
                    {state.alldata && 
                    state.alldata.map((mydata, index) => (

                        (mydata.id === null) ?
                          <li className="list-group-item"><h6>{mydata.mtype}</h6></li>
                          :
                          (mydata.mtype === 'Médecin') ? <button type="button" className="list-group-item list-group-item-action"
                          onClick={() => onClickSelectDoctor(mydata.id,mydata.name)}>
                            {mydata.name} <br/><small>{mydata.libelle_specialite}</small>
                          </button>
                          :
                          (mydata.mtype === 'Structure') ? <button type="button" className="list-group-item list-group-item-action"
                          onClick={() => onClickSelectStructure(mydata.id,mydata.name)}>
                            {mydata.name}
                          </button>
                          :
                          (mydata.mtype === 'Spécialité') && <button type="button" className="list-group-item list-group-item-action"
                          onClick={() => onClickSelectSpecialite(mydata.id,mydata.name)}>
                            {mydata.name}
                          </button>
                      )
                      
                      )}
                    </div>
                  )}
                </td>
                <td style={{width:"50%"}}>
                {(state.focusedLieu &&
                <div className="list-group" style={{width:"45%",position:"absolute",zIndex:"auto",height:"300px",overflow:"auto"}}>
                  <button type="button" className="list-group-item list-group-item-action"
                    onMouseDown={() => onClickSelectLieu('0','Autour de moi')}>
                    <FontAwesomeIcon style={{color:"gray"}} icon={solid('location-arrow')} size={'xl'}/>  Autour de moi
                  </button>
                  {state.alldatalieu &&
                    state.alldatalieu.map((lieu, index) => (
                      <button type="button" className="list-group-item list-group-item-action"
                        onMouseDown={() => onClickSelectLieu(lieu.idlieu,lieu.libelle_sub_terr+' ('+lieu.tut+')')}>
                          {lieu.libelle_type_sub_terr+' '+lieu.libelle_sub_terr+' ('+lieu.tut+')'} 
                        </button>
                    ))}
                  
                </div> 
              )}
                </td></tr></tbody></table>

                <div className="text-center" style={{marginTop:"30px",marginBottom:"100px"}}>
                </div>     
            </div>
           
  );
};

export default GlobalSearch;